import { api } from "@/api"
import type { UserAuthResponse } from "../sharedTypes/users"

const { setToken } = useAuth()
const { setUser } = useCurrentUser()

export const logInMagicLink = async (token: string) => {
  const {
    body: { accessToken, user },
  } = await api.post<{
    accessToken: string
    user: UserAuthResponse
  }>("/auth/handle-login-link/", {
    body: {
      token: token,
    },
    authenticated: false,
  })
  setUser(user)
  setToken(accessToken)
  return { accessToken, user }
}
